module.exports = __webpack_public_path__ + "static/img/18.984e3de.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/sp/18.png
// module id = jflo
// module chunks = 0